import "@fortawesome/fontawesome-svg-core/styles.css";
import "@fontsource/source-sans-pro/300.css";
import "@fontsource/source-sans-pro/400.css";
import "@fontsource/source-sans-pro/600.css";
import "@fontsource/source-sans-pro/700.css";

// Slick slider CSS
import "~/assets/css/slick.css";

// Swiper JS CSS
import "swiper/css";

import { navigate } from "gatsby";

let nextRoute = ``;

export const onPreRouteUpdate = async ({ location }) => {
    nextRoute = location.pathname;

    /**
     * Why are we hard-coding these values?
     * Please refer to ticket below for more details!
     *
     * @ticket CW-2479
     * @ticket CW-2777
     */
    const params = new URLSearchParams(location.search);
    if (location.pathname === "/knowledge-center/") {
        if (
            params.get("topics") === "powerful-perspectives-articles" ||
            params.get("topics") === "powerful-perspectives" ||
            params.get("types") === "thought-leadership"
        ) {
            await navigate("/powerful-perspectives/");
        }
    }
    let didChangeParams = false;
    if (location.pathname.includes("/power/")) {
        let technology = params.get("technology");
        if (
            technology &&
            (technology.includes("CMHSA") || technology.includes("EMSWA"))
        ) {
            technology = technology.replace("CMHSA", "C4MS");
            technology = technology.replace("EMSWA", "E4MS");
            params.set("technology", technology);
            didChangeParams = true;
        }
        let packageParam = params.get("package");
        if (packageParam && packageParam.includes("TSC (U2)")) {
            packageParam = packageParam.replace("TSC (U2)", "U2 (TSC)");
            params.set("package", packageParam);
            didChangeParams = true;
        }
        if (packageParam && packageParam.includes("Q (TSC)")) {
            packageParam = packageParam.replace("Q (TSC)", "Q-TSC");
            params.set("package", packageParam);
            didChangeParams = true;
        }

        if (didChangeParams) {
            window.location.search = params.toString();
        }
    }
};

export const shouldUpdateScroll = ({ routerProps }) => {
    if (routerProps.location.state) {
        const { disableScrollUpdate } = routerProps.location.state;
        return !disableScrollUpdate;
    }
};

if (typeof window !== `undefined`) {
    window.addEventListener("unhandledrejection", function (event) {
        if (/loading chunk \d* failed./i.test(event.reason)) {
            if (nextRoute) {
                window.location.pathname = nextRoute;
            }
        }
    });

    document.onvisibilitychange = () => {
        if (
            typeof window.trackAbandonedCart === "function" &&
            document.visibilityState === "hidden"
        ) {
            window.trackAbandonedCart();
        }
    };

    if (!window.crypto) {
        window.crypto = window.msCrypto;
    }
}

export { wrapRootElement } from "./gatsby-ssr";

export { wrapPageElement } from "./gatsby-ssr";
